import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=5ac1b913&"
import script from "./BaseData.vue?vue&type=script&lang=js&"
export * from "./BaseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports